import React from 'react';
import './Notice.css';

const Notice = ({ type = 'info', message, onClose }) => {
  const icons = {
    info: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <path d="M12 8h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M11 12h1v4h1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    warning: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 9v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M12 17.01l.01-.011" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M10.615 3.892c.628-1.15 2.142-1.15 2.77 0l8.25 15.125C22.266 20.18 21.466 22 20 22H4c-1.466 0-2.266-1.82-1.635-2.983l8.25-15.125z" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
    success: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    error: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <path d="M15 9l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M9 9l6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    )
  };

  const titles = {
    info: 'Info',
    warning: 'Warning',
    success: 'Success',
    error: 'Error'
  };

  return (
    <div className={`notice notice-${type}`}>
      <div className="notice-icon">
        {icons[type]}
      </div>
      <div className="notice-content">
        <div className="notice-title">{titles[type]}</div>
        <div className="notice-message">{message}</div>
      </div>
      {onClose && (
        <button className="notice-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      )}
    </div>
  );
};

export default Notice; 